import { Component } from 'react';
import { connect } from 'react-redux';
import api from 'api';
import { getFormattedDate } from 'lib/common';
import { LoadingIndicator } from 'components/common';
import { Box } from 'components/common/box';
import { BarChart } from 'components/common/charts';
import { StatItem } from 'components/common/stats';

const AnalyticsCoursesCompletions = connect((state) => state)(
  class extends Component {
    state = { completions: {}, loading: true };

    componentDidMount() {
      this.updateData();
    }

    componentDidUpdate(prevProps) {
      const { fromDate, toDate } = this.props;
      if (fromDate !== prevProps.fromDate || toDate !== prevProps.toDate) {
        this.updateData();
      }
    }

    updateData = async () => {
      try {
        this.setState({ loading: true });
        const { fromDate, toDate } = this.props;
        const completions = await api.get(
          `/admin/analytics/course-completions` +
            `?fromDate=${fromDate}` +
            `&toDate=${toDate}`
        );
        this.setState({
          completions: completions.data.completions,
          loading: false
        });
      } catch (err) {
        this.setState({ loading: false });
        await this.props.dispatch.handleErrorDispatch(err);
      }
    };

    render() {
      const { fromDate, toDate, messages, theme } = this.props;
      const { completions, loading } = this.state;

      const data = completions.data
        ? completions.data.map((entry) => ({
            label: entry.label,
            [messages.commonCourseCompletions]: entry.count
          }))
        : null;

      return (
        <div className="completions">
          <Box
            style={{ height: '100%' }}
            title={messages.commonCourseCompletions}
            headerContent={
              <div className="date">
                {`${getFormattedDate({ date: fromDate })} - ${getFormattedDate({
                  date: toDate
                })}`}
              </div>
            }
            headerContentWrap={true}
          >
            <div className="header">
              <div className="total">
                <StatItem
                  align="left"
                  horizontal={true}
                  small={true}
                  label={messages.analyticsCourseCompletionsInTotal}
                  value={completions?.totalCount}
                />
              </div>
            </div>

            {loading ? (
              <LoadingIndicator style={{ padding: '130px 50px' }} />
            ) : (
              <BarChart
                data={data}
                height={260}
                xAxisDataKey="label"
                yAxisDataKey={messages.commonCourseCompletions}
              />
            )}
          </Box>

          <style jsx>{`
            .date {
              color: ${theme.textColorLighter};
              font-size: 1.4rem;
              font-weight: 400;
            }
            .completions {
              height: 100%;
            }
            .header {
              padding: 10px 5px;
            }
          `}</style>
        </div>
      );
    }
  }
);

export default AnalyticsCoursesCompletions;
